import React from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ImageOverlayButton from "./image-overlay-button";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";

export const RaceCard = ({
  title,
  time,
  runners,
  backgroundImage,
  onClick,
}) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        width: {
          xs: "47%",
          md: "49%", // Full width on extra small screens
          lg: "48%", // 3 cards per row on medium screens and up
          xl: "32%", // 3 cards per row on medium screens and up
        },
        height: isMediumScreen ? 180 : 200,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover", // Ensure the image covers the entire area
        backgroundPosition: "center", // Center the image
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        "&:hover": {
          boxShadow: "-2px 0px 14px rgba(199, 183, 40, 0.27)", // Shadow
          cursor: "pointer", // Change cursor on hover
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: "absolute",

          bottom: 0,
          top: 0,
          left: 0,
          right: 0,
          borderRadius: "12px",
          // width: 200,
          // p: ,
          pl: isMediumScreen ? 2 : 4,
          pt: 3,
          backgroundImage: isMediumScreen
            ? "linear-gradient(to right, #171717 0%, #171717 5%, rgba(23, 23, 23, 0) 100%)"
            : "linear-gradient(to right, #171717 0%, #171717 42%, rgba(23, 23, 23, 0) 100%)",
        }}
      >
        <Typography
          textAlign={"left"}
          mb={1}
          fontSize={isMediumScreen ? fontSizes.heading3 : fontSizes.heading2}
          fontFamily={"MontserratBold"}
          color={darkColors.primary}
        >
          {title}
        </Typography>
        <Typography
          mb={1}
          textAlign={"left"}
          fontSize={isMediumScreen ? fontSizes.body : fontSizes.heading3}
          fontFamily={"MontserratBold"}
          color={darkColors.buttonTop}
        >
          {time}
        </Typography>
        <Typography
          textAlign={"left"}
          mb={2.5}
          fontSize={isMediumScreen ? fontSizes.body : fontSizes.heading3}
          color={darkColors.betOnRaces}
        >
          {runners} Runners
        </Typography>
        <Box>
          <ImageOverlayButton
            text={"WATCH"}
            fontSize={fontSizes.info}
            textColor={darkColors.primary}
            borderColor={darkColors.primary}
            width={88} // Optional: Adjust width if needed
          />
        </Box>
      </Box>
    </Box>
  );
};
